import { matchPath } from 'react-router-dom';
import { EXTENSION_CATALOG } from '../extensions/extensionRegistry';

const coreRoutes = [
  { path: '/settings/order-workflow/:section', i18nKey: 'orders.workflow_settings_title' },
  { path: '/settings/order-workflow', i18nKey: 'orders.workflow_settings_title', exact: true },
  { path: '/settings', i18nKey: 'settings.title', exact: true },
  { path: '/users/new', i18nKey: 'users.create' },
  { path: '/users/:id/edit', i18nKey: 'users.edit' },
  { path: '/users', i18nKey: 'users.title', exact: true },
  { path: '/customers/new', i18nKey: 'customers.create' },
  { path: '/customers/:id/edit', i18nKey: 'customers.edit' },
  { path: '/customers', i18nKey: 'customers.title', exact: true },
  { path: '/products/new', i18nKey: 'products.create' },
  { path: '/products/:id/edit', i18nKey: 'products.edit' },
  { path: '/products', i18nKey: 'products.title', exact: true },
  { path: '/orders/new', i18nKey: 'orders.create' },
  { path: '/orders/:id/edit', i18nKey: 'orders.edit' },
  { path: '/orders', i18nKey: 'orders.title', exact: true },
  { path: '/medias', i18nKey: 'media.title', exact: true },
  { path: '/profile', i18nKey: 'profile.title', exact: true },
  { path: '/workspaces/new', i18nKey: 'workspace.create' },
  { path: '/admin/backup', i18nKey: 'admin_backup.title', exact: true },
  { path: '/extensions', i18nKey: 'extensions.page_title', exact: true },
  { path: '/', i18nKey: 'home.dashboard.page_title', exact: true },
];

export const resolveLayoutPageTitle = (translate, pathname) => {
  for (const ext of EXTENSION_CATALOG) {
    if (ext.nestedRoutes?.routes) {
      for (const r of ext.nestedRoutes.routes) {
        const pattern = r.index ? ext.route : `${ext.route.replace(/\/$/, '')}/${r.path}`;
        const m = matchPath({ path: pattern, end: true }, pathname);
        if (m && r.titleKey) {
          return translate(r.titleKey);
        }
      }
    }
    if (ext.route && matchPath({ path: ext.route, end: true }, pathname)) {
      return translate(ext.menuItem?.labelKey || ext.nameKey);
    }
  }

  for (const r of coreRoutes) {
    const m = matchPath({ path: r.path, end: r.exact ?? false }, pathname);
    if (m) {
      return translate(r.i18nKey);
    }
  }

  return translate('home.dashboard.page_title');
};
